export const isMicroApp = Boolean((window as any).__POWERED_BY_QIANKUN__);

let hostToken = '';

export function setHostToken(token: string) {
    hostToken = token;
}

export function getHostToken() {
    return hostToken || undefined;
}
